<template>
  <div class="loading-bar">
    <div class="loading-bar__progress" :style="{transform: `scaleX(${progress}) translateZ(0)`}" />
    <div class="loading-bar__effect" />
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'

.loading-bar
  position absolute
  bottom 20px
  width 60%
  left 20%
  height 10px
  border-radius 10px
  overflow hidden
  
  &__progress
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    transform-origin 0 50%
    background: $colors.red

  &__effect 
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    opacity .6
    background linear-gradient(0deg, rgba(120,120,120,0.36) 0%, rgba(255,255,255,0.31) 11%, rgba(255,255,255,0.3) 23%, rgba(255,255,255,0.56) 41%, rgba(255,255,255,0.7) 54%, rgba(255,255,255,0.36) 67%, rgba(255,255,255,0.3) 73%, rgba(255,255,255,0.3) 74%, rgba(255,255,255,0.36) 85%, rgba(60,60,60,0.36) 100%)
    
    &:after
      content ''
      position absolute
      top 0
      left 0
      width 100%
      height 100%
      background linear-gradient(90deg, rgba(255,255,255,0.55) 0%, rgba(255,255,255,0) 1.5%, rgba(255,255,255,0) 98.5%, rgba(255,255,255,0.55) 100%)
      

</style>